import type { GetStaticProps } from 'next'

import { NewtClient } from '@/utils/NewtClient'

import { VideoPage } from '@/components/pages/News/Video'

import type { Video as VideoType } from '@/types/video'

type VideoProps = {
  videoList: readonly VideoType[]
}

const Video = ({ videoList }: VideoProps) => {
  return <VideoPage videoInfoList={videoList[0].strategy} />
}

export const getStaticProps: GetStaticProps = async () => {
  const client = new NewtClient()
  const videoList = await client.fetchVideoList()

  return {
    props: {
      videoList,
    },
  }
}

export default Video
